import React from "react";
import { Route, Routes } from "react-router-dom";
import NewMemberPage from "./NewMemberPage";
import EditMemberPage from "./EditMemberPage";
import MemberListPage from "./ListMemberPage";
import MemberExpired from "./MemberExpired";

export default function MemberPage() {
  return (
    <Routes>
      <Route path="/new" element={<NewMemberPage />} />
      <Route path="/edit" element={<EditMemberPage />} />
      <Route path="/list" element={<MemberListPage />} />
      <Route path="/expired" element={<MemberExpired />} />
    </Routes>
  );
}
